/**
 * SpendingPage — the Spending tab: what you spent this month (as a list or a calendar)
 * on one page; categories are managed inline. Importing a statement is a button, not a tab.
 */
import React from 'react';
import TrackerPage from './TrackerPage';
import SpendingCalendar from './SpendingCalendar';
import ImportPage from './ImportPage';

export default function SpendingPage({ sub, setSub, ...props }) {
  const view = sub === 'calendar' || sub === 'import' ? sub : 'list';
  const { state, updateState, showToast } = props;

  if (view === 'import') {
    return (
      <div>
        <button className="btn-link back-btn" onClick={() => setSub('list')}>
          ← Back to spending
        </button>
        <ImportPage state={state} updateState={updateState} showToast={showToast} />
      </div>
    );
  }

  return (
    <div>
      <div className="spend-top">
        <div className="subtabs">
          <button className={'subtab' + (view === 'list' ? ' on' : '')} onClick={() => setSub('list')}>
            📋 List
          </button>
          <button className={'subtab' + (view === 'calendar' ? ' on' : '')} onClick={() => setSub('calendar')}>
            📅 Calendar
          </button>
        </div>
        <button className="import-btn" onClick={() => setSub('import')}>
          📥 Import statement
        </button>
      </div>
      {view === 'list' ? <TrackerPage {...props} /> : <SpendingCalendar state={state} />}
    </div>
  );
}
